var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 30,
    height: 30,
    rx: 2,
    fill: "#343337"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9626 16.1342C27.104 17.0941 26.7132 18.0346 26.1978 18.7C25.6463 19.4137 24.6958 19.9657 23.7748 19.9369C23.6067 19.0178 24.0371 18.0708 24.5609 17.4343C25.1355 16.7317 26.1202 16.1927 26.9626 16.1342ZM29.7293 29.6463C30.2041 28.9187 30.3814 28.5516 30.75 27.7301C28.0693 26.7106 27.6397 22.8995 30.2927 21.4368C29.4835 20.422 28.3464 19.8337 27.273 19.8337C26.4996 19.8337 25.9697 20.0356 25.4879 20.2191C25.0865 20.372 24.7184 20.5121 24.2708 20.5121C23.7872 20.5121 23.3588 20.3585 22.9103 20.1977C22.4175 20.021 21.9003 19.8356 21.2585 19.8356C20.0539 19.8356 18.7718 20.5716 17.9589 21.8299C16.8162 23.6021 17.0111 26.9337 18.8642 29.7718C19.5265 30.7875 20.4114 31.9287 21.5689 31.9389C22.0492 31.9437 22.3687 31.8003 22.7146 31.6452C23.1104 31.4677 23.5407 31.2747 24.2856 31.2707C25.035 31.2663 25.4584 31.4616 25.849 31.6417C26.186 31.7972 26.4985 31.9413 26.9746 31.9361C28.133 31.9268 29.0669 30.662 29.7293 29.6463Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.6bcebdad0ffe6482f08827e4b7dece4e.svg";
export { ForwardRef as ReactComponent };